import { Injectable, Inject } from '@angular/core';
import { DwOrmDataService, DwOrmDataServiceToken, DwCacheService, DwQueryHelper } from '@devwareapps/devware-cap';
import { RequestEntity, TemplateEntity, AppMetaDataService, CompanyEntity } from 'src/app/meta-data/app-meta-data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppMetaDataItemNames } from '../../../meta-data/app-meta-data.service';

@Injectable({
  providedIn: 'root'
})
export class EquipRequestService {

  constructor(
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private cacheService: DwCacheService,
  ) { }

  /**
   * Create a new template
   * @param name Template Name
   * @param request Request Template
   */
  createTemplate(templateName: string, requestTemplate: RequestEntity): Observable<TemplateEntity> {
    const template: TemplateEntity = this.dataService.createDummyEntity(AppMetaDataItemNames.Template);

    template.Name = templateName;
    template.SettingsJson =  JSON.stringify(requestTemplate);
    return this.dataService.saveEntity(template);
  }


  /**
   * Gets a cached list of companies
   */
  getEquipmentCompanies(): Observable<CompanyEntity[]> {
    const md = new AppMetaDataService();
    const cacheInvalidationTopics: string[] = [];

    // Invalidate cache if the company table is updated
    cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.Company));

    // Return cached data
    return this.cacheService.get('EquipmentCompanies', this.loadEquipmentCompanies(), null, cacheInvalidationTopics);
  }

  /**
   * Get a cache company
   * @param companyId companyId
   */
  getEquipmentCompany(companyId: number) {
    if (typeof companyId === 'string') {
      companyId = parseInt(companyId, 10);
    }
    return this.getEquipmentCompanies()
      .pipe(map(companies => {
          const foundCompany = companies.find(c => c.CompanyId === companyId);
          // if (!foundCompany) {
          //   console.error(`Company Id {companyId} was not found in the list of companies`, companies);
          // }
          return foundCompany;
      }));
  }

  /**
   * Run a query to load all compnaes
   */
  private loadEquipmentCompanies(): Observable<CompanyEntity[]> {
    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.Company.CreateQuery();

    return this.dataService.executeQuery(query);
  }
  generateHtml(request: any){
    let company : Observable<string> = this.getEquipmentCompany(request.CompanyId).pipe(map(x => x.Company));
    let companyString : string;
    let requestId : number;
    company.subscribe(x => companyString = x);
    let equipment = '';
    request.RequestEquipment.forEach(x => {
      equipment += `<tr>
    <td style="width: 155.8pt; border: solid windowtext 1.0pt; border-top: none; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + x.Quantity + `</span></strong></p>
    </td>
    <td style="width: 155.85pt; border-top: none; border-left: none; border-bottom: solid windowtext 1.0pt; border-right: solid windowtext 1.0pt; background: #FFF2CC; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong>` + x.EquipmentIdDisplay + `</strong></p>
    </td>
    <td style="width: 155.85pt; border-top: none; border-left: none; border-bottom: solid windowtext 1.0pt; border-right: solid windowtext 1.0pt; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + (x.Comments == null ? `` : x.Comments) + `</span></strong></p>
    </td>
    </tr>`
    requestId = x.requestId

    });
    let html: string = `<table style="border-collapse: collapse; border: none;">
    <tbody>
    <tr>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">Request ID:</p>
    </td>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;"><em><span style="color: #767171;">` + request.RequestId + `</span></em></p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">Requested:</p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;"><em><span style="color: #767171;">` +  (new Date).toLocaleString()+ `</span></em></p>
    </td>
    </tr>
    <tr>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">Company:</p>
    </td>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;"><em><span style="font-family: 'Calibri-Italic',sans-serif; color: #767171;">` + companyString + `</span></em></p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">&nbsp;</p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;">&nbsp;</p>
    </td>
    </tr>
    <tr>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">To Email:</p>
    </td>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;"><em><span style="font-family: 'Calibri-Italic',sans-serif; color: #767171;">` + request.CompanyEmail + `</span></em></p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">&nbsp;</p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;">&nbsp;</p>
    </td>
    </tr>
    <tr>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">CC Email:</p>
    </td>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;"><em><span style="font-family: 'Calibri-Italic',sans-serif; color: #767171;">` + request.EmailCopyString + `</span></em></p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">&nbsp;</p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;">&nbsp;</p>
    </td>
    </tr>
    <tr>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">Account #:</p>
    </td>
    <td style="width: 116.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;"><em><span style="color: #c10000;font-weight: bold;">` + request.AcountNumber + `</span></em></p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal; text-autospace: none;">&nbsp;</p>
    </td>
    <td style="width: 116.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="156">
    <p style="margin-bottom: .0001pt; line-height: normal; text-autospace: none;">&nbsp;</p>
    </td>
    </tr>
    </tbody>
    </table>
    <p><span style="color: #404040;">&nbsp;</span></p>
    <p><strong>` + (request.DeliveryOptionCv == 130 ? `We need delivered to site` : (request.DeliveryOptionCv == 132 ? `We need quote for` : `We will pick up at branch`))  + `</strong></p>
    <table style="border-collapse: collapse; border: none;">
    <tbody>
    <tr>
    <td style="width: 155.8pt; border: none; background: #D0CECE; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong>QTY:</strong></p>
    </td>
    <td style="width: 155.85pt; border: none; background: #D0CECE; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong>Equipment/Supplies:</strong></p>
    </td>
    <td style="width: 155.85pt; border: none; background: #D0CECE; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong>Comments/Instructions:</strong></p>
    </td>
    </tr>` +
    equipment
     + `
    </tbody>
    </table>
    <p><strong>&nbsp;</strong></p>
    <table style="border-collapse: collapse; border: none;">
    <tbody>
    <tr>
    <td style="width: 155.8pt; background: #E7E6E6; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong>Pre-Deliver By:</strong></p>
    </td>
    <td style="width: 155.85pt; background: #E7E6E6; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong>Rental Start by Date:</strong></p>
    </td>
    <td style="width: 155.85pt; background: #E7E6E6; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong>Rental End by Date:</strong></p>
    </td>
    </tr>
    <tr>
    <td style="width: 155.8pt; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + new Date(request.NeededByDateTime).toLocaleString() + `</span></strong></p>
    </td>
    <td style="width: 155.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + new Date(request.DeliveredByDateTime).toLocaleString() + `</span></strong></p>
    </td>
    <td style="width: 155.85pt; padding: 0in 5.4pt 0in 5.4pt;" width="208">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + (request.IsAutoPickup ? new Date(request.PickupByDateTime).toLocaleString() : ``) + `</span></strong></p>
    </td>
    </tr>
    </tbody>
    </table>
    <p><strong>&nbsp;</strong></p>
    <table style="border-collapse: collapse; border: none;">
    <tbody>
    <tr>
    <td style="width: 77.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="104">
    <p style="margin-bottom: .0001pt; line-height: normal;"><span style="color: windowtext;">Auto-PickUp?</span></p>
    </td>
    <td style="width: 77.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="104">
    <p style="margin-bottom: .0001pt; text-align: center; line-height: normal;"><strong><span style="color: windowtext;">` + (request.IsAutoPickup === true ? `<input type="checkbox" checked>` : `<input type="checkbox">`) + `</span></strong></p>
    </td>
    <td style="width: 77.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="104">
    <p style="margin-bottom: .0001pt; line-height: normal;"><span style="color: windowtext;">Substitutions Allowed?</span></p>
    </td>
    <td style="width: 77.9pt; padding: 0in 5.4pt 0in 5.4pt;" width="104">
    <p style="margin-bottom: .0001pt; text-align: center; line-height: normal;"><strong><span style="color: windowtext;">` + (request.AreSubstitutionsAllowed === true ? `<input type="checkbox" checked>` : `<input type="checkbox">`)+ `</span></strong></p>
    </td>
    <td style="width: 77.95pt; padding: 0in 5.4pt 0in 5.4pt;" width="104">
    <p style="margin-bottom: .0001pt; line-height: normal;"><span style="color: windowtext;">Protection Plan?</span></p>
    </td>
    <td style="width: 77.95pt; padding: 0in 5.4pt 0in 5.4pt;" width="104">
    <p style="margin-bottom: .0001pt; text-align: center; line-height: normal;"><strong><span style="color: windowtext;">` + (request.HasProtectionPlan === true ? `<input type="checkbox" checked>` : `<input type="checkbox">`) + `</span></strong></p>
    </td>
    </tr>
    </tbody>
    </table>
    <p><strong>&nbsp;</strong></p>
    <p><strong><span style="font-size: 10.0pt; line-height: 107%; font-family: Arial-BoldItalicMT; color: #c10000;">▲ </span></strong><strong><em><span style="font-size: 10.0pt; line-height: 107%; font-family: 'Calibri-BoldItalic',sans-serif; color: #c10000;">Notice: Any delivery/pickup charges outside of Wachter's contracted rates need approval beforehand!</span></em></strong></p>
    <p>Comments/Notes:</p>
    <p><strong> ` + (request.Notes == null ? ``: request.Notes) + ` </strong></p>
    <table style="border-collapse: separate; border-spacing: 0 20px;">
    <tbody>

    <tr>
    <td style="width: 112.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="150">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal;"><span style="color: windowtext;">Job Name</span></p>
    </td>
    <td style="width: 355.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="474">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + (request.JobName == null ? ``: request.JobName) + `</span></strong></p>
    </td>
    </tr>

    <tr>
    <td style="width: 112.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="150">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal;"><span style="color: windowtext;">PO/Job #:</span></p>
    </td>
    <td style="width: 355.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="474">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + (request.JobNumber == null ? ``: request.JobNumber) + `</span></strong></p>
    </td>
    </tr>
    <tr>
    <td style="width: 112.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="150">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal;"><span style="color: windowtext;">Job Site Address:</span></p>
    </td>
    <td style="width: 355.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="474">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + (request.JobSiteAddress == null ? ``: request.JobSiteAddress) + `</span></strong></p>
    </td>
    </tr>
    <tr>
    <td style="width: 112.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="150">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal;"><span style="color: windowtext;">Site Contact Name:</span></p>
    </td>
    <td style="width: 355.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="474">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + (request.SiteContactName == null ? ``: request.SiteContactName) + `</span></strong></p>
    </td>
    </tr>
    <tr>
    <td style="width: 112.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="150">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal;"><span style="color: windowtext;">Site Contact Number:</span></p>
    </td>
    <td style="width: 355.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="474">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + (request.SiteContactPhoneNumber == null ? ``: request.SiteContactPhoneNumber) + `</span></strong></p>

    </td>
    </tr>
    <tr>
    <td style="width: 112.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="150">
    <p style="margin-bottom: .0001pt; text-align: right; line-height: normal;"><strong><span style="color: windowtext;">Drop Off Area:</span></strong></p>
    </td>
    <td style="width: 355.25pt; padding: 0in 5.4pt 0in 5.4pt;" width="474">
    <p style="margin-bottom: .0001pt; line-height: normal;"><strong><span style="color: windowtext;">` + (request.DropOffArea == null ? `` : request.DropOffArea) + `</span></strong></p>

    </td>
    </tr>
    </tbody>
    </table>
    <p><strong>&nbsp;</strong></p>
    <p><strong>Thank You!</strong></p>
    <p><strong>` + (request.RequesterNameAndNumber == null ? `` : request.RequesterNameAndNumber) +  `</strong></p>
    <p style="text-align: center;"><strong>&nbsp;</strong></p>
    <p style="margin-bottom: .0001pt; text-align: center; line-height: normal; text-autospace: none;"><strong><em><span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; color: #c10000;">- NOTICE: -</span></em></strong></p>
    <p style="margin-bottom: .0001pt; text-align: center; line-height: normal; text-autospace: none;"><em><span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; color: #c10000;">Wachter will NOT remain on site. To help reduce the risk of theft or vandalism,</span></em></p>
    <p style="text-align: center;"><em><span style="font-size: 10.0pt; line-height: 107%; font-family: 'Arial',sans-serif; color: #c10000;">please <strong>pick-up equipment within 4 business days </strong>of call-off request. Thank You!</span></em></p>
    <p><a href="http://www.wachter.com/">www.wachter.com</a></p>`;
    return html;
  }
}
